import { Box, Grid, Paper, Typography } from "@mui/material";
import { red, amber } from "@mui/material/colors";
import { localizarErro, moeda } from "../../shared/apresentacaoEvento";

function ErrosProcessamento({ ocorrencia }) {
  if (
    !ocorrencia.evento ||
    !ocorrencia.evento.enviosEvento ||
    ocorrencia.evento.enviosEvento.length === 0
  ) {
    return null;
  }

  const { enviosEvento } = ocorrencia.evento;
  const ultimoEnvio = [...enviosEvento].sort(
    (a, b) => Number(b.id) - Number(a.id)
  )[0];

  if (!(ultimoEnvio.errosProcessamento?.length || ultimoEnvio.erroInterno)) {
    return null;
  }

  const mensagens = [...(ultimoEnvio.errosProcessamento || [])].sort(
    (a, b) => b.id - a.id
  );
  const erros = mensagens.filter((err) => err.tipoErroProcessamento?.id !== 2);
  const advertencias = mensagens.filter(
    (err) => err.tipoErroProcessamento?.id === 2
  );

  return (
    <>
      {(erros.length > 0 || ultimoEnvio.erroInterno) && (
        <Box
          component={Paper}
          padding={2}
          sx={{ backgroundColor: red[50] }}
          marginBottom={advertencias.length ? 2 : 0}
        >
          <Typography variant="h6" sx={{ fontSize: "1rem" }} gutterBottom>
            Erros
          </Typography>
          <Grid container spacing={2}>
            {erros.map((erro) => (
              <Grid item key={erro.id}>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  Código: {erro.codMensagem}
                </Typography>
                <Typography variant="body2">{erro.descricao}</Typography>
                <ContextoErro dados={ocorrencia.dadosOcorrencia} erro={erro} />
                {erro.localizacao && (
                  <Typography variant="body2" sx={{ overflowWrap: "anywhere" }}>
                    {erro.localizacao}
                  </Typography>
                )}
              </Grid>
            ))}
            {ultimoEnvio.erroInterno && (
              <Grid item>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  Erro interno
                </Typography>
                <Typography variant="body2">
                  {ultimoEnvio.erroInterno}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      )}
      {advertencias.length > 0 && (
        <Box component={Paper} padding={2} sx={{ backgroundColor: amber[200] }}>
          <Typography variant="h6" sx={{ fontSize: "1rem" }} gutterBottom>
            Advertências
          </Typography>
          <Grid container spacing={2}>
            {advertencias.map((erro) => (
              <Grid item key={erro.id}>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  Código: {erro.codMensagem}
                </Typography>
                <Typography variant="body2">{erro.descricao}</Typography>
                {erro.localizacao && (
                  <Typography variant="body2" sx={{ overflowWrap: "anywhere" }}>
                    {erro.localizacao}
                  </Typography>
                )}
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </>
  );
}

function ContextoErro({ dados, erro }) {
  const encontrado = localizarErro(dados, erro.localizacao);
  if (!encontrado) return null;
  const c = encontrado.contexto;
  const infos = [
    c.ideDmDev && `Demonstrativo: ${c.ideDmDev}`,
    c.codRubr !== undefined && `Rubrica: ${c.codRubr}`,
    c.ideTabRubr && `Tabela: ${c.ideTabRubr}`,
    c.vrRubr !== undefined && `Valor: ${moeda(c.vrRubr)}`,
    c.vrLiq !== undefined && `Líquido: ${moeda(c.vrLiq)}`
  ].filter(Boolean);
  if (
    !infos.length &&
    encontrado.valor !== null &&
    typeof encontrado.valor !== "object"
  )
    infos.push(`Valor informado: ${encontrado.valor}`);
  return infos.length ? (
    <Typography
      variant="body2"
      sx={{ mt: 1, fontWeight: 600, overflowWrap: "anywhere" }}
    >
      {infos.join(" · ")}
    </Typography>
  ) : null;
}

export default ErrosProcessamento;
